import login from './login';
import mediafax from './mediafax';
import chat from './chat';
import account from './account';
import dict from './dictionary';
import caseApi from './case';
import tweet from './tweet';
import customer from './customer';
import service from './service';
import task from './task';
import sso from './sso';
import remark from './remark';
import enquiry from './enquiry';
import website from './website';
import taskflow from './taskflow';
import workorder from './workOrder';
import seo from './seo';
import setmeal from './setmeal';
import googleAds from './googleAds';
import fbReport from './fbReport';
import garbageInquiry from './garbageInquiry';
import coupon from './coupon';
import visitor from './visitor';
import kit from './kit';
import evaluate from './evaluate';
import setting from './setting';
import liveChat from './liveChat';
import adsNewOnline from './adsNewOnline';
import flowAnalysis from './flowAnalysis';
import indexData from './indexData';
import emailHost from './emailHost';
import keywordRanking from './keywordRanking';
import accessrecord from './accessrecord';
import sem from './sem';
import welcomePage from './welcomePage';
import websiteMonitor from './websiteMonitor';
import siteSeoAnalysis from './siteSeoAnalysis';
import seoTakeDown from './seoTakeDown';
import inspection from './inspection';

function addHost(json, host) {
	Object.keys(json).forEach(key => {
		const api = json[key];
		json[key] = `${host}${api}`;
	});
	return json;
}

export default function ({ iglobalwinHost, ssoHost, oaHost }) {
	let Apis = {
		chat: addHost(chat, iglobalwinHost),
		loginApi: addHost(login, iglobalwinHost),
		mediafax: addHost(mediafax, iglobalwinHost),
		dictApi: addHost(dict, iglobalwinHost),
		customer: addHost(customer, iglobalwinHost),
		case: addHost(caseApi, iglobalwinHost),
		tweet: addHost(tweet, iglobalwinHost),
		account: addHost(account, iglobalwinHost),
		service: addHost(service, iglobalwinHost),
		task: addHost(task, iglobalwinHost),
		sso: sso({ ssoHost, oaHost }),
		remark: addHost(remark, iglobalwinHost),
		inquiry: addHost(enquiry, iglobalwinHost),
		website: addHost(website, iglobalwinHost),
		taskflow: addHost(taskflow, iglobalwinHost),
		workorder: addHost(workorder, iglobalwinHost),
		seo: addHost(seo, iglobalwinHost),
		setmeal: addHost(setmeal, iglobalwinHost),
		googleAds: addHost(googleAds, iglobalwinHost),
		fbReport: addHost(fbReport, iglobalwinHost),
		garbageInquiry: addHost(garbageInquiry, iglobalwinHost),
		coupon: addHost(coupon, iglobalwinHost),
		visitor: addHost(visitor, iglobalwinHost),
		kit: addHost(kit, iglobalwinHost),
		evaluate: addHost(evaluate, iglobalwinHost),
		setting: addHost(setting, iglobalwinHost),
		liveChat: addHost(liveChat, iglobalwinHost),
		adsNewOnline: addHost(adsNewOnline, iglobalwinHost),
		flowAnalysis: addHost(flowAnalysis, iglobalwinHost),
		indexData: addHost(indexData, iglobalwinHost),
		emailHost: addHost(emailHost, iglobalwinHost),
		keywordRanking: addHost(keywordRanking, iglobalwinHost),
		accessrecord: addHost(accessrecord, iglobalwinHost),
		sem: addHost(sem, iglobalwinHost),
		welcomePage: addHost(welcomePage, iglobalwinHost),
		websiteMonitor: addHost(websiteMonitor, iglobalwinHost),
		siteSeoAnalysis: addHost(siteSeoAnalysis, iglobalwinHost),
		seoTakeDown: addHost(seoTakeDown, iglobalwinHost),
		inspection: addHost(inspection, iglobalwinHost),
	};

	return Apis;
}
